<script lang="ts">
    import type {Document} from 'src/typings';
    import {getInjector, getLocalization} from 'src/core';
    import {KpVisitedPanelPresenter} from './kp-visited-panel.presenter';
    import {onMount} from 'svelte';
    import KpDocumentMini from '../../../features/record/kp-document-mini/KpDocumentMini.svelte';
    import KpGenericPanel from 'shared/ui-widgets/panel/KpGenericPanel.svelte';
    import {exists} from 'shared/utils/custom-utils';

    export let showLastVisited = true;

    const localize = getLocalization();
    const presenter = getInjector().getByClass(KpVisitedPanelPresenter);

    let visited: Document[] | undefined;

    onMount(async () => {
        visited = await presenter.getVisitedDocuments(showLastVisited)
    });
</script>

{#if exists(visited) && visited.length > 0}
    <section class="kp-visited-panel visited-container" aria-labelledby="visited-panel-label">
        <KpGenericPanel>
            <h2 id="visited-panel-label" class="unset-style" slot="heading">
                {localize(/* @kp-localization commons.navstivene */ 'commons.navstivene')}
            </h2>

            {#each visited as document}
                <div class="document">
                    <KpDocumentMini document={document}/>
                </div>
            {/each}
        </KpGenericPanel>
    </section>
{/if}

<style lang="less">
    .kp-visited-panel {
        .document {
            margin-bottom: 10px;
        }
    }
</style>